import {
  getProPlanFeatures,
  PROACTIVE_PLAN_FEATURES,
} from "@/components/modal/paywall/plan-features";

interface SubscriptionFeatureListOptions {
  chatMessageFeatureLabel?: string;
}

const DEFAULT_FREE_CHAT_MESSAGE_FEATURE_LABEL = "25 chat messages per month";

export const getFreeFeatures = ({
  chatMessageFeatureLabel = DEFAULT_FREE_CHAT_MESSAGE_FEATURE_LABEL,
}: SubscriptionFeatureListOptions = {}): string[] => [
  "25 notes per month",
  chatMessageFeatureLabel,
  "25 PDF pages in search and chat",
];

export const getProFeatures = ({
  chatMessageFeatureLabel,
}: SubscriptionFeatureListOptions = {}): string[] =>
  getProPlanFeatures({ chatMessageFeatureLabel });

export const getProactiveFeatures = (): string[] => [...PROACTIVE_PLAN_FEATURES];
